import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header-cuenta-cobro-domicilio',
  templateUrl: './header-cuenta-cobro-domicilio.component.html',
  styleUrls: ['./header-cuenta-cobro-domicilio.component.css']
})
export class HeaderCuentaCobroDomicilioComponent implements OnInit {

  loading: boolean;
  downloading: boolean;

  @Output() filtrosSeleccionados: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.onGenerar();
  }

  onGenerar() {
    this.filtrosSeleccionados.emit({});
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    var left = (screen.width/2) - (screen.width / 4);
    printContents = document.getElementById('print-area').innerHTML;
    popupWin = window.open('', '_blank', `height=800px,width=1200px,left=${left}`);
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }


}
